import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  /* Status badges */
  earnedStatusBadge: {
    id: 'earned.status.badge',
    defaultMessage: 'Earned',
  },
  notEarnedStatusBadge: {
    id: 'not.earned.status.badge',
    defaultMessage: 'Not Earned',
  },
  partiallyCompletedStatusBadge: {
    id: 'partially.completed.status.badge',
    defaultMessage: 'Partially Completed',
  },
});

export default messages;
